<template>
<div style="height: 100%;overflow-y: auto">
<!--  离床 inbed = 2-->
<!--  在床 inbed = 1 status = 0-->
<!--  翻身 inbed = 1 status = 1-->
  <div v-if="moduletag === 2" style="margin: 0 20px;padding-top: 20px;height: 50px;color: #FFFFFF">
    <span>楼栋/楼层：</span>
    <el-cascader v-fixZoom style="width: 300px" :options="orgOptions" class="input-el" clearable
                 v-model="orgid" :filterable="true" placeholder="请选择"
                 :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                 ref="orgOptions" @change="changeOrgData">
    </el-cascader>
    <el-button type="primary" @click="getDataRoom">查看</el-button>
  </div>
  <div v-if="moduletag === 1" style="padding-top: 20px;height: 50px;margin: 0 20px;color: #FFFFFF">
    <span>组织：</span>
    <el-cascader v-fixZoom style="width: 320px" :options="orgOptions" class="input-el" clearable
                 v-model="orgid" :filterable="true" placeholder="请选择"
                 :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                 ref="orgOptions" >
    </el-cascader>
    <el-button type="primary" @click="getDataRoom">查看</el-button>
  </div>
  <div style="height: calc(100% - 70px);overflow-y: auto">
    <div style="height: 50px;font-size: 20px;color: #FFFFFF;text-align: center" v-if="roomInfo.length === 0"><span>暂无数据</span></div>
    <div class="box-item" v-for="item in roomInfo" :key="item.id">
      <div class="bg-box">
        <div class="address-top">
          <img style="vertical-align: middle" src="../../assets/healthIcon/room.png">
          <span style="vertical-align: middle">
            <span>{{item.orglevelnameShow}} / </span>
            <span>{{item.room}}</span>
          </span>
        </div>
        <div class="carousel-box">
          <div class="bed-list-left">
            <div v-if="item.bedArr.length === 1" class="bed-border">
              <div class="one-bed" style="margin: 0 80px;">
                <div class="one-three-top"><span style="font-size: 18px" v-if="item.bedArr[0]">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                <div class="one-three-top"><span v-if="item.bedArr[0]">{{ item.bedArr[0].bed_name }}</span><span v-else> -- </span></div>
                <div class="one-three-bed">
                  <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-2-Y.png">
                  <img v-else src="../../assets/healthIcon/bed-2-N.png">
                </div>
                <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 18px;text-align: center">
                  <el-row>
                    <el-col :span="12">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-2.png">
                      <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                      <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                    </el-col>
                    <el-col :span="12">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-2.png">
                      <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                      <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;font-size: 16px;text-align: center;color: #FFFFFF">
                  <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 18px;color: #ffcd05">
                    <span v-if="item.bedArr[0].status === 0">正常</span>
                    <span v-if="item.bedArr[0].status === 1">翻身</span>
                    <span v-if="item.bedArr[0].status === 2">安静</span>
                    <span v-if="item.bedArr[0].status === 3">动作</span>
                    <span v-if="item.bedArr[0].status === 4">持续动作</span>
                    <span v-if="item.bedArr[0].status === 5">无人</span>
                    <span v-if="item.bedArr[0].status === 6">平静</span>
                  </span>
                  <span v-else style="font-size: 18px;color: #ffcd05"> -- </span><br>
                  <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 12px;">{{item.bedArr[0].sleep_time}}</span>
                </div>
              </div>
            </div>
            <div v-if="item.bedArr.length === 2" class="bed-border">
              <el-row>
                <el-col :span="12">
                  <div class="one-bed">
                    <div class="one-three-top"><span style="font-size: 18px" v-if="item.bedArr[0]">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-top"><span v-if="item.bedArr[0]">{{ item.bedArr[0].bed_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-bed">
                      <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-2-Y.png">
                      <img v-else src="../../assets/healthIcon/bed-2-N.png">
                    </div>
                    <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                      <el-row>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-2.png">
                          <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                          <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                        </el-col>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-2.png">
                          <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                          <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                      <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 18px;color: #ffcd05">
                        <span v-if="item.bedArr[0].status === 0">正常</span>
                         <span v-if="item.bedArr[0].status === 1">翻身</span>
                         <span v-if="item.bedArr[0].status === 2">安静</span>
                         <span v-if="item.bedArr[0].status === 3">动作</span>
                         <span v-if="item.bedArr[0].status === 4">持续动作</span>
                         <span v-if="item.bedArr[0].status === 5">无人</span>
                         <span v-if="item.bedArr[0].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 18px;color: #ffcd05"> -- </span><br>
                      <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 12px;">{{item.bedArr[0].sleep_time}}</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12" style="border-left: 1px solid #3a4968">
                  <div class="one-bed">
                    <div class="one-three-top"><span style="font-size: 18px" v-if="item.bedArr[1]">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-top"><span v-if="item.bedArr[1]">{{ item.bedArr[1].bed_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-bed">
                      <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-2-Y.png">
                      <img v-else src="../../assets/healthIcon/bed-2-N.png">
                    </div>
                    <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                      <el-row>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-2.png">
                          <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                          <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                        </el-col>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-2.png">
                          <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                          <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                      <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 18px;color: #ffcd05">
                        <span v-if="item.bedArr[1].status === 0">正常</span>
                         <span v-if="item.bedArr[1].status === 1">翻身</span>
                         <span v-if="item.bedArr[1].status === 2">安静</span>
                         <span v-if="item.bedArr[1].status === 3">动作</span>
                         <span v-if="item.bedArr[1].status === 4">持续动作</span>
                         <span v-if="item.bedArr[1].status === 5">无人</span>
                         <span v-if="item.bedArr[1].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 18px;color: #ffcd05"> -- </span><br>
                      <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 12px;">{{item.bedArr[1].sleep_time}}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="item.bedArr.length === 3" class="bed-border">
              <el-row>
                <el-col :span="8">
                  <div class="one-bed">
                    <div class="one-three-top"><span style="font-size: 16px" v-if="item.bedArr[0]">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-top"><span v-if="item.bedArr[0]">{{ item.bedArr[0].bed_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-bed">
                      <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-3-y.png">
                      <img v-else src="../../assets/healthIcon/bed-3-n.png">
                    </div>
                    <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                      <el-row>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-3.png">
                          <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                          <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                        </el-col>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-3.png">
                          <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                          <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                      <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 14px;color: #ffcd05">
                        <span v-if="item.bedArr[0].status === 0">正常</span>
                         <span v-if="item.bedArr[0].status === 1">翻身</span>
                         <span v-if="item.bedArr[0].status === 2">安静</span>
                         <span v-if="item.bedArr[0].status === 3">动作</span>
                         <span v-if="item.bedArr[0].status === 4">持续动作</span>
                         <span v-if="item.bedArr[0].status === 5">无人</span>
                         <span v-if="item.bedArr[0].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 14px;color: #ffcd05"> -- </span><br>
                      <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 10px;">{{item.bedArr[0].sleep_time}}</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8" style="border-left: 1px solid #3a4968">
                  <div class="one-bed">
                    <div class="one-three-top"><span style="font-size: 16px" v-if="item.bedArr[1]">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-top"><span v-if="item.bedArr[1]">{{ item.bedArr[1].bed_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-bed">
                      <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-3-y.png">
                      <img v-else src="../../assets/healthIcon/bed-3-n.png">
                    </div>
                    <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                      <el-row>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-3.png">
                          <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                          <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                        </el-col>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-3.png">
                          <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                          <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                      <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 14px;color: #ffcd05">
                        <span v-if="item.bedArr[1].status === 0">正常</span>
                         <span v-if="item.bedArr[1].status === 1">翻身</span>
                         <span v-if="item.bedArr[1].status === 2">安静</span>
                         <span v-if="item.bedArr[1].status === 3">动作</span>
                         <span v-if="item.bedArr[1].status === 4">持续动作</span>
                         <span v-if="item.bedArr[1].status === 5">无人</span>
                         <span v-if="item.bedArr[1].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 14px;color: #ffcd05"> -- </span><br>
                      <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 10px;">{{item.bedArr[1].sleep_time}}</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8" style="border-left: 1px solid #3a4968">
                  <div class="one-bed">
                    <div class="one-three-top"><span style="font-size: 16px" v-if="item.bedArr[2]">{{ item.bedArr[2].person_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-top"><span v-if="item.bedArr[2]">{{ item.bedArr[2].bed_name }}</span><span v-else> -- </span></div>
                    <div class="one-three-bed">
                      <img v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" src="../../assets/healthIcon/bed-3-y.png">
                      <img v-else src="../../assets/healthIcon/bed-3-n.png">
                    </div>
                    <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                      <el-row>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-3.png">
                          <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[2].heartbeat}}</strong>
                          <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                        </el-col>
                        <el-col :span="12">
                          <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-3.png">
                          <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[2].breathe}}</strong>
                          <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                        </el-col>
                      </el-row>
                    </div>
                    <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                      <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 14px;color: #ffcd05">
                        <span v-if="item.bedArr[2].status === 0">正常</span>
                         <span v-if="item.bedArr[2].status === 1">翻身</span>
                         <span v-if="item.bedArr[2].status === 2">安静</span>
                         <span v-if="item.bedArr[2].status === 3">动作</span>
                         <span v-if="item.bedArr[2].status === 4">持续动作</span>
                         <span v-if="item.bedArr[2].status === 5">无人</span>
                         <span v-if="item.bedArr[2].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 14px;color: #ffcd05"> -- </span><br>
                      <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 10px;">{{item.bedArr[2].sleep_time}}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="item.bedArr.length === 4" class="bed-border">
              <el-row style="margin: 0 10px">
                <el-col :span="12" style="height: 133px;border-right: 1px solid #3a4968">
                  <div class="one-three-top"><span v-if="item.bedArr[0]">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                  <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[0]">{{ item.bedArr[0].bed_name }}</span><span v-else> -- </span></div>
                  <el-col :span="12">
                    <div style="height: 30px;text-align: center">
                      <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                      <img v-else src="../../assets/healthIcon/bed-4-n.png">
                    </div>
                    <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 14px;color: #ffcd05">
                        <span v-if="item.bedArr[0].status === 0">正常</span>
                         <span v-if="item.bedArr[0].status === 1">翻身</span>
                         <span v-if="item.bedArr[0].status === 2">安静</span>
                         <span v-if="item.bedArr[0].status === 3">动作</span>
                         <span v-if="item.bedArr[0].status === 4">持续动作</span>
                         <span v-if="item.bedArr[0].status === 5">无人</span>
                         <span v-if="item.bedArr[0].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                    </div>
                  </el-col>
                  <el-col v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" :span="12">
                    <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                      <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                      <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                    </div>
                    <div style="height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                      <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                      <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                    </div>
                  </el-col>
                </el-col>
                <el-col :span="12" style="height: 133px;border-bottom: 1px solid #3a4968">
                  <div class="one-three-top"><span v-if="item.bedArr[1]">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                  <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[1]">{{ item.bedArr[1].bed_name }}</span><span v-else> -- </span></div>
                  <el-col :span="12">
                    <div style="height: 30px;text-align: center">
                      <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                      <img v-else src="../../assets/healthIcon/bed-4-n.png">
                    </div>
                    <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 14px;color: #ffcd05">
                        <span v-if="item.bedArr[1].status === 0">正常</span>
                         <span v-if="item.bedArr[1].status === 1">翻身</span>
                         <span v-if="item.bedArr[1].status === 2">安静</span>
                         <span v-if="item.bedArr[1].status === 3">动作</span>
                         <span v-if="item.bedArr[1].status === 4">持续动作</span>
                         <span v-if="item.bedArr[1].status === 5">无人</span>
                         <span v-if="item.bedArr[1].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                    </div>
                  </el-col>
                  <el-col v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" :span="12">
                    <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                      <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                      <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                    </div>
                    <div style="height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                      <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                      <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                    </div>
                  </el-col>
                </el-col>
                <el-col :span="12" style="height: 133px;border-top: 1px solid #3a4968">
                  <div class="one-three-top"><span v-if="item.bedArr[2]">{{ item.bedArr[2].person_name }}</span><span v-else> -- </span></div>
                  <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[2]">{{ item.bedArr[2].bed_name }}</span><span v-else> -- </span></div>
                  <el-col :span="12">
                    <div style="height: 30px;text-align: center">
                      <img v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                      <img v-else src="../../assets/healthIcon/bed-4-n.png">
                    </div>
                    <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 14px;color: #ffcd05">
                        <span v-if="item.bedArr[2].status === 0">正常</span>
                         <span v-if="item.bedArr[2].status === 1">翻身</span>
                         <span v-if="item.bedArr[2].status === 2">安静</span>
                         <span v-if="item.bedArr[2].status === 3">动作</span>
                         <span v-if="item.bedArr[2].status === 4">持续动作</span>
                         <span v-if="item.bedArr[2].status === 5">无人</span>
                         <span v-if="item.bedArr[2].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                    </div>
                  </el-col>
                  <el-col v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" :span="12">
                    <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                      <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[2].heartbeat}}</strong>
                      <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                    </div>
                    <div style="height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                      <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[2].breathe}}</strong>
                      <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                    </div>
                  </el-col>
                </el-col>
                <el-col :span="12" style="height: 133px;border-left: 1px solid #3a4968">
                  <div class="one-three-top"><span v-if="item.bedArr[3]">{{ item.bedArr[3].person_name }}</span><span v-else> -- </span></div>
                  <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[3]">{{ item.bedArr[3].bed_name }}</span><span v-else> -- </span></div>
                  <el-col :span="12">
                    <div style="height: 30px;text-align: center">
                      <img v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                      <img v-else src="../../assets/healthIcon/bed-4-n.png">
                    </div>
                    <div v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" style="font-size: 14px;color: #ffcd05">
                        <span v-if="item.bedArr[3].status === 0">正常</span>
                         <span v-if="item.bedArr[2].status === 1">翻身</span>
                         <span v-if="item.bedArr[2].status === 2">安静</span>
                         <span v-if="item.bedArr[2].status === 3">动作</span>
                         <span v-if="item.bedArr[2].status === 4">持续动作</span>
                         <span v-if="item.bedArr[2].status === 5">无人</span>
                         <span v-if="item.bedArr[2].status === 6">平静</span>
                      </span>
                      <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                    </div>
                  </el-col>
                  <el-col v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" :span="12">
                    <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                      <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[3].heartbeat}}</strong>
                      <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                    </div>
                    <div style="height: 30px;text-align: center;font-size: 14px;">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                      <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[3].breathe}}</strong>
                      <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                    </div>
                  </el-col>
                </el-col>
              </el-row>
            </div>
            <div v-if="item.bedArr.length === 5 || item.bedArr.length === 6" class="bed-border">
              <el-col :span="8" style="height: 133px;border-right: 1px solid #3a4968">
                <div class="one-three-top"><span v-if="item.bedArr[0]">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[0]">{{ item.bedArr[0].bed_name }}</span><span v-else> -- </span></div>
                <el-col :span="12">
                  <div style="height: 30px;text-align: center">
                    <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                    <img v-else src="../../assets/healthIcon/bed-4-n.png">
                  </div>
                  <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                    <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[0].status === 0">正常</span>
                         <span v-if="item.bedArr[0].status === 1">翻身</span>
                         <span v-if="item.bedArr[0].status === 2">安静</span>
                         <span v-if="item.bedArr[0].status === 3">动作</span>
                         <span v-if="item.bedArr[0].status === 4">持续动作</span>
                         <span v-if="item.bedArr[0].status === 5">无人</span>
                         <span v-if="item.bedArr[0].status === 6">平静</span>
                    </span>
                    <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                  </div>
                </el-col>
                <el-col v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" :span="12">
                  <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                    <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                  </div>
                  <div style="height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                    <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="8" style="height: 133px;border-right: 1px solid #3a4968">
                <div class="one-three-top"><span v-if="item.bedArr[1]">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[1]">{{ item.bedArr[1].bed_name }}</span><span v-else> -- </span></div>
                <el-col :span="12">
                  <div style="height: 30px;text-align: center">
                    <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                    <img v-else src="../../assets/healthIcon/bed-4-n.png">
                  </div>
                  <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                    <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[1].status === 0">正常</span>
                         <span v-if="item.bedArr[1].status === 1">翻身</span>
                         <span v-if="item.bedArr[1].status === 2">安静</span>
                         <span v-if="item.bedArr[1].status === 3">动作</span>
                         <span v-if="item.bedArr[1].status === 4">持续动作</span>
                         <span v-if="item.bedArr[1].status === 5">无人</span>
                         <span v-if="item.bedArr[1].status === 6">平静</span>
                    </span>
                    <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                  </div>
                </el-col>
                <el-col v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" :span="12">
                  <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                    <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                  </div>
                  <div style="height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                    <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="8" style="height: 133px;border-bottom: 1px solid #3a4968">
                <div class="one-three-top"><span v-if="item.bedArr[2]">{{ item.bedArr[2].person_name }}</span><span v-else> -- </span></div>
                <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[2]">{{ item.bedArr[2].bed_name }}</span><span v-else> -- </span></div>
                <el-col :span="12">
                  <div style="height: 30px;text-align: center">
                    <img v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                    <img v-else src="../../assets/healthIcon/bed-4-n.png">
                  </div>
                  <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                    <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[2].status === 0">正常</span>
                         <span v-if="item.bedArr[2].status === 1">翻身</span>
                         <span v-if="item.bedArr[2].status === 2">安静</span>
                         <span v-if="item.bedArr[2].status === 3">动作</span>
                         <span v-if="item.bedArr[2].status === 4">持续动作</span>
                         <span v-if="item.bedArr[2].status === 5">无人</span>
                         <span v-if="item.bedArr[2].status === 6">平静</span>
                    </span>
                    <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                  </div>
                </el-col>
                <el-col v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" :span="12">
                  <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                    <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[2].heartbeat}}</strong>
                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                  </div>
                  <div style="height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                    <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[2].breathe}}</strong>
                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="8" style="height: 133px;border-top: 1px solid #3a4968;border-right: 1px solid #3a4968">
                <div class="one-three-top"><span v-if="item.bedArr[3]">{{ item.bedArr[3].person_name }}</span><span v-else> -- </span></div>
                <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[3]">{{ item.bedArr[3].bed_name }}</span><span v-else> -- </span></div>
                <el-col :span="12">
                  <div style="height: 30px;text-align: center">
                    <img v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                    <img v-else src="../../assets/healthIcon/bed-4-n.png">
                  </div>
                  <div v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                    <span v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" style="font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[3].status === 0">正常</span>
                         <span v-if="item.bedArr[3].status === 1">翻身</span>
                         <span v-if="item.bedArr[3].status === 2">安静</span>
                         <span v-if="item.bedArr[3].status === 3">动作</span>
                         <span v-if="item.bedArr[3].status === 4">持续动作</span>
                         <span v-if="item.bedArr[3].status === 5">无人</span>
                         <span v-if="item.bedArr[3].status === 6">平静</span>
                    </span>
                    <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                  </div>
                </el-col>
                <el-col v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" :span="12">
                  <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                    <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[3].heartbeat}}</strong>
                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                  </div>
                  <div style="height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                    <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[3].breathe}}</strong>
                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="8" style="height: 133px;border-top: 1px solid #3a4968;border-right: 1px solid #3a4968">
                <div class="one-three-top"><span v-if="item.bedArr[4]">{{ item.bedArr[4].person_name }}</span><span v-else> -- </span></div>
                <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[4]">{{ item.bedArr[4].bed_name }}</span><span v-else> -- </span></div>
                <el-col :span="12">
                  <div style="height: 30px;text-align: center">
                    <img v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                    <img v-else src="../../assets/healthIcon/bed-4-n.png">
                  </div>
                  <div v-if="item.bedArr[4] && item.bedArr[4].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                    <span v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].inbed === 1" style="font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[4].status === 0">正常</span>
                         <span v-if="item.bedArr[4].status === 1">翻身</span>
                         <span v-if="item.bedArr[4].status === 2">安静</span>
                         <span v-if="item.bedArr[4].status === 3">动作</span>
                         <span v-if="item.bedArr[4].status === 4">持续动作</span>
                         <span v-if="item.bedArr[4].status === 5">无人</span>
                         <span v-if="item.bedArr[4].status === 6">平静</span>
                    </span>
                    <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                  </div>
                </el-col>
                <el-col v-if="item.bedArr[4] && item.bedArr[4].sleep_id !== 0" :span="12">
                  <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                    <strong v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[4].heartbeat}}</strong>
                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                  </div>
                  <div style="height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                    <strong v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[4].breathe}}</strong>
                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                  </div>
                </el-col>
              </el-col>
              <el-col v-if="item.bedArr.length === 6" :span="8" style="height: 133px;border-right: 1px solid #3a4968">
                <div class="one-three-top"><span v-if="item.bedArr[5]">{{ item.bedArr[5].person_name }}</span><span v-else> -- </span></div>
                <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[5]">{{ item.bedArr[5].bed_name }}</span><span v-else> -- </span></div>
                <el-col :span="12">
                  <div style="height: 30px;text-align: center">
                    <img v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                    <img v-else src="../../assets/healthIcon/bed-4-n.png">
                  </div>
                  <div v-if="item.bedArr[5] && item.bedArr[5].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                    <span v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].inbed === 1" style="font-size: 14px;color: #ffcd05">
                      <span v-if="item.bedArr[5].status === 0">正常</span>
                         <span v-if="item.bedArr[5].status === 1">翻身</span>
                         <span v-if="item.bedArr[5].status === 2">安静</span>
                         <span v-if="item.bedArr[5].status === 3">动作</span>
                         <span v-if="item.bedArr[5].status === 4">持续动作</span>
                         <span v-if="item.bedArr[5].status === 5">无人</span>
                         <span v-if="item.bedArr[5].status === 6">平静</span>
                    </span>
                    <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                  </div>
                </el-col>
                <el-col v-if="item.bedArr[5] && item.bedArr[5].sleep_id !== 0" :span="12">
                  <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                    <strong v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[5].heartbeat}}</strong>
                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                  </div>
                  <div style="height: 30px;text-align: center;font-size: 14px;">
                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                    <strong v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[5].breathe}}</strong>
                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                  </div>
                </el-col>
              </el-col>
            </div>
          </div>
          <div class="toilet-right">
            <div class="bg-toilet" v-if="item.radarArr.length === 1">
              <div style="height: 50px"></div>
              <div style="height: 40px;font-size: 12px;overflow-wrap: break-word;overflow-y: hidden">
                <span>{{item.radarArr[0].remark}}</span>
              </div>
              <div style="height: 90px" v-if="!item.radarArr[0].radarOnlinde">
                <img src="../../assets/healthIcon/wuren.png">
              </div>
              <div style="height: 90px" v-else>
                <img v-if="item.radarArr[0].radarstatus === 'human_exist'" src="../../assets/healthIcon/youren.png">
                <img v-else-if="item.radarArr[0].radarstatus === 'stranded_alarm'" src="../../assets/healthIcon/zhiliu.png">
                <img v-else src="../../assets/healthIcon/wuren.png">
              </div>
              <div style="height: 30px;line-height: 30px;font-size: 16px" v-if="item.radarArr[0].did !== 0">
                <span v-if="!item.radarArr[0].radarOnlinde">离线</span>
                <span v-else>
                  <span v-if="item.radarArr[0].radarstatus === 'human_exist'" style="color: #22da52">有人</span>
                  <span v-else-if="item.radarArr[0].radarstatus === 'human_not_exist'" style="color: #999999">无人</span>
                  <span v-else-if="item.radarArr[0].radarstatus === 'stranded_alarm'" style="color: #f55167">滞留</span>
                  <strong v-if="item.radarArr[0].radarstatus === '' && item.radarArr[0].radartime === ''"> -- </strong>
                </span>
              </div>
              <div v-if="item.radarArr[0] && item.radarArr[0].radarstatus !== 'human_not_exist'" style="height: 20px;font-size: 12px">
<!--                <span v-if="item.radarArr[0]">{{ item.radarArr[0].radartime }}</span>-->
                <span v-if="item.radarArr[0]">{{ item.radarArr[0].radarOnTime }}</span>
              </div>
            </div>
            <div class="bg-toilet" v-else-if="item.radarArr.length === 2">
              <div :class="index === 0 ? 'list-toilet' : 'list-toilet1'" v-for="(list, index) in item.radarArr" :key="index">
                <div style="height: 30px;font-size: 12px;overflow-wrap: break-word;overflow-y: hidden"><span>{{list.remark}}</span></div>
                <div class="person-icon">
                  <span v-if="!list.radarOnlinde">
                    <img style="vertical-align: middle;height: 55px" src="../../assets/healthIcon/ren1.png">
                  </span>
                  <span v-else>
                    <img style="vertical-align: middle;height: 55px" v-if="list.radarstatus === 'human_exist'" src="../../assets/healthIcon/ren2.png">
                    <img style="vertical-align: middle;height: 55px" v-else-if="list.radarstatus === 'stranded_alarm'" src="../../assets/healthIcon/ren3.png">
                    <img style="vertical-align: middle;height: 55px" v-else src="../../assets/healthIcon/ren1.png">
                  </span>
                  <span v-if="!list.radarOnlinde">离线</span>
                  <span v-else>
                    <span v-if="list.radarstatus === 'human_exist'" style="color: #22da52">有人</span>
                    <span v-else-if="list.radarstatus === 'human_not_exist'" style="color: #999999">无人</span>
                    <span v-else-if="list.radarstatus === 'stranded_alarm'" style="color: #f55167">滞留</span>
                    <strong v-if="list.radarstatus === '' && list.radartime === ''"> -- </strong>
                  </span>
                </div>
                <div class="text-line1" v-if="list.radarOnlinde && list.radarstatus !== 'human_not_exist'" style="font-size: 12px">
<!--                  <span v-if="list">{{ list.radartime }}</span>-->
                  <span v-if="list">{{ list.radarOnTime }}</span>
                </div>
              </div>
            </div>
            <div class="bg-toilet" v-else-if="item.radarArr.length > 2">
              <div :class="(index1 === 2 && item.radarArr.length === 3) ? 'list-toilet4' : 'list-toilet3'" v-for="(list1, index1) in item.radarArr" :key="index1">
                <div style="height: 20px;font-size: 10px;overflow-wrap: break-word;overflow:hidden;"><span>{{list1.remark}}</span></div>
                <div class="person-icon1">
                  <span v-if="!list1.radarOnlinde">
                    <img style="vertical-align: middle;height: 30px" src="../../assets/healthIcon/wu-12.png">
                  </span>
                  <span v-else>
                    <img style="vertical-align: middle;height: 30px" v-if="list1.radarstatus === 'human_exist'" src="../../assets/healthIcon/you-12.png">
                    <img style="vertical-align: middle;height: 30px" v-else-if="list1.radarstatus === 'stranded_alarm'" src="../../assets/healthIcon/bao-12.png">
                    <img style="vertical-align: middle;height: 30px" v-else src="../../assets/healthIcon/ren1.png">
                  </span>
                  <span v-if="!list1.radarOnlinde">离线</span>
                  <span v-else>
                    <span v-if="list1.radarstatus === 'human_exist'" style="color: #22da52">有人</span>
                    <span v-else-if="list1.radarstatus === 'human_not_exist'" style="color: #999999">无人</span>
                    <span v-else-if="list1.radarstatus === 'stranded_alarm'" style="color: #f55167">滞留</span>
                    <strong v-if="list1.radarstatus === '' && list1.radartime === ''"> -- </strong>
                  </span>
                </div>
                <div class="text-line1" v-if="list1.radarOnlinde && list1.radarstatus !== 'human_not_exist'" style="font-size: 12px">
<!--                  <span v-if="list1">{{ list1.radartime }}</span>-->
                  <span v-if="list1">{{ list1.radarOnTime }}</span>
                </div>
              </div>
            </div>
            <div class="bg-toilet" v-else>
              <div style="height: 50px"></div>
              <div style="height: 40px;line-height: 40px;font-size: 12px"><span></span></div>
              <div style="height: 90px">
                <img src="../../assets/healthIcon/wuren.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {queryorghomewithbed, queryroomhealth} from '../../api/yanglaoyuan'
import {queryorg} from '../../api/organizer'

export default {
  name: 'healthDetection',
  data () {
    return {
      roomInfo: [],
      healthdata: [],
      orghomes: [],
      timer: null,
      orgOptions: [],
      orgid: '',
      orgArr: [],
      sendData: {
        build_id: 0,
        floor_id: 0
      },
      moduletag: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    this.golobleObject.updateTableAlarm = this.mqttData // mqtt推送
    this.getOrgData()
  },
  mounted () {
    let vm = this
    this.timer = setInterval(() => {
      vm.getRadarSleep()
    }, 10 * 60 * 1000)
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    // 组织
    getOrgData () {
      queryorg().then(res => {
        this.orgArr = this.clone(res.data.org)
        this.getOrTree()
        this.getDataRoom()
      }).catch(() => {})
    },
    getOrTree () {
      // 所属组织
      let lastLevel = 100
      const arr = []
      for (let i = 0; i < this.orgArr.length; i++) {
        let obj = this.orgArr[i]
        if (this.orgArr[i].level < lastLevel) {
          lastLevel = this.orgArr[i].level
        }
        if (this.moduletag === 2 && this.orgArr[i].org_type === 0) {
          obj.disabled = true
        } else {
          obj.disabled = false
        }
        arr.push(obj)
      }
      let treeData = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          treeData.push(arr[i])
        }
      }
      for (let i = 0; i < treeData.length; i++) {
        const child = this.arrayToNode(arr, treeData[i].id)
        if (child.length !== 0) {
          treeData[i].child = child
        }
      }
      // console.log(999, arr, treeData)
      this.orgOptions = treeData
    },
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // mqtt
    mqttData () {
      this.getRadarSleep()
    },
    // 获取全部房间（雷达信息）
    getDataRoom () {
      let params = {
        page: 1,
        size: 9999
      }
      let data = {
        build_id: this.sendData.build_id,
        floor_id: this.sendData.floor_id
      }
      queryorghomewithbed(params, data).then(res => {
        this.orghomes = res.data.orghomes
        this.getRadarSleep()
      }).catch(() => {})
    },
    // 获取雷达睡眠带数据
    getRadarSleep () {
      let params = {
        page: 1,
        size: 9999
      }
      // console.log(7890)
      let data = {
        build_id: this.sendData.build_id,
        floor_id: this.sendData.floor_id
      }
      queryroomhealth(params, data).then(res => {
        this.healthdata = this.clone(res.data.healthdata)
        this.getListShow()
      })
    },
    getListShow () {
      let arr = []
      let orghomes = this.orghomes
      for (let i = 0; i < orghomes.length; i++) {
        let obj = orghomes[i]
        let name = ''
        let nameArr = obj.orglevelname.split('/')
        for (let j = 1; j < nameArr.length; j++) {
          name = name === '' ? nameArr[j] : (name + '/' + nameArr[j])
        }
        obj.orglevelnameShow = name
        for (let j = 0; j < obj.maindevice.length; j++) {
          obj.maindevice[j].isOnline = false
          if (obj.maindevice[j].device_type === 405 || obj.maindevice[j].device_type === 407 || obj.maindevice[j].device_type === 752) {
            // wifi雷达 特殊 25分钟显示离线 (主机雷达、子机雷达需要主机来判断离线）
            let d1 = new Date(obj.maindevice[j].last_online)
            let d2 = new Date()
            if ((parseInt(d2 - d1) / 1000 / 60) < 25) {
              obj.maindevice[j].isOnline = true
            }
          } else {
            // 15分钟显示离线
            let d1 = new Date(obj.maindevice[j].last_online)
            let d2 = new Date()
            if ((parseInt(d2 - d1) / 1000 / 60) < 15) {
              obj.maindevice[j].isOnline = true
            }
          }
        }
        obj.radarArr = []
        obj.bedArr = []
        for (let j = 0; j < obj.homebed.length; j++) {
          let val = obj.homebed[j]
          val.breathe = 0
          val.heartbeat = 0
          val.inbed = 0
          val.status = 0
          val.person_name = '空'
          val.sleep_id = 0
          val.sleep_time = ''
          val.sleep_online = false // 时间差为5分钟视为离线
          this.healthdata.forEach(item => {
            if (item.hid === obj.id) {
              item.sleep_status_info.forEach(sleep => {
                if (sleep.bid === val.id) {
                  val.breathe = sleep.breathe
                  val.heartbeat = sleep.heartbeat
                  val.inbed = sleep.inbed
                  val.status = sleep.status
                  val.person_name = sleep.person_name
                  val.sleep_id = sleep.sleep_id
                  val.sleep_time = sleep.sleep_time
                  if (val.sleep_time !== '') {
                    const currentTime = new Date().getTime()
                    const sleepTime = new Date(sleep.sleep_time).getTime()
                    const timeDifference = currentTime - sleepTime
                    // 如果时间差小于等于5分钟(300000毫秒)，则认为设备在线
                    sleep.sleep_online = timeDifference <= 5 * 60 * 1000
                  }
                }
              })
            }
          })
          obj.bedArr.push(val)
        }

        this.healthdata.forEach(item => {
          if (item.hid === obj.id) {
            let aa = []
            for (let j = 0; j < item.subradar.length; j++) {
              item.subradar[j].radarOnlinde = false
              item.subradar[j].radarOnTime = ''
              obj.maindevice.forEach(device => {
                if (device.did === item.subradar[j].did) {
                  item.subradar[j].radarOnlinde = device.isOnline
                }
              })
              if (item.subradar[j].radarOnlinde && item.subradar[j].radartime !== '') {
                item.subradar[j].radarOnTime = this.util.calculateTimeDifference(item.subradar[j].radartime)
                // 超过一个小时视为无人
                let t1 = new Date(item.subradar[j].radartime)
                let t2 = new Date()
                if ((parseInt(t2 - t1) / 1000 / 60 / 60) > 1) {
                  item.subradar[j].radarstatus = 'human_not_exist'
                }
              }
              aa.push(item.subradar[j])
            }
            obj.radarArr = aa
          }
        })
        arr.push(obj)
      }
      this.roomInfo = arr
      console.log(999, arr)
    },
    changeOrgData (val) {
      console.log(val)
      let nodesObj = this.$refs['orgOptions'].getCheckedNodes()[0] ? this.$refs['orgOptions'].getCheckedNodes()[0].data : ''
      // console.log(nodesObj)
      this.sendData = {
        build_id: 0,
        floor_id: 0
      }
      if (nodesObj === '') {
        return
      }
      if (nodesObj.org_type === 1) {
        this.sendData.build_id = nodesObj.id
      } else if (nodesObj.org_type === 2) {
        this.sendData.floor_id = nodesObj.id
      }
    }
  }
}
</script>

<style scoped>
.box-item{
  float: left;
  width: 33%;
}
.bg-box{
  margin: 10px 15px;
  /*width: 400px;*/
  height: 350px;
  background: url("../../assets/healthIcon/room_bg.png") no-repeat;
  background-size: 100% 100%;
}
.address-top{
  margin: 0 15px;
  height: 40px;
  line-height: 50px;
  font-size: 18px;
  color: #FFFFFF;
}
.carousel-box{
  margin-top: 10px;
  height: 280px;
}
.bed-list-left{
  width: calc(100% - 125px);
  margin-left: 15px;
  height: 280px;
  float: left;
}
.bed-border{
  padding: 10px 0;
  height: 260px;
  box-shadow: 0px 0px 9px 0px
  rgba(111, 112, 113, 0.26);
  border-radius: 3px;
  border: solid 1px #3a4968;
}
.one-bed{
  padding-top: 40px;
  height: 220px;
}
.one-three-top{
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
}
.one-three-bed{
  margin-top: 10px;
  height: 50px;
  text-align: center;
}
.toilet-right{
  width: 110px;
  height: 190px;
  float: left;
}
.bg-toilet{
  margin: auto;
  width: 80px;
  height: 280px;
  box-shadow: 0px 0px 9px 0px
  rgba(111, 112, 113, 0.26);
  border-radius: 3px;
  border: solid 1px #3a4968;
  text-align: center;
  color: #FFFFFF;
  overflow-y: auto;
}
.list-toilet{
  height: 129px;
  margin: 5px;
  border-bottom: 1px solid #3A4968;
}
.list-toilet1{
  height: 129px;
  margin: 5px;
}
.text-line{
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
}
.text-line1{
  margin-top: 5px;
  height: 30px;
  font-size: 12px;
  overflow: hidden;
}
.person-icon{
  font-size: 14px;
  height: 55px;
  text-align: center;
}
.person-icon1{
  font-size: 12px;
  height: 30px;
  text-align: center;
}
.list-toilet3{
  height: 85px;
  margin: 5px;
  border-bottom: 1px solid #3A4968;
}
.list-toilet4{
  height: 85px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/healthDetection.vue